import { render, staticRenderFns } from "./referentmodal.vue?vue&type=template&id=03884652"
import script from "./referentmodal.vue?vue&type=script&lang=js"
export * from "./referentmodal.vue?vue&type=script&lang=js"
import style0 from "./referentmodal.vue?vue&type=style&index=0&id=03884652&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports